var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vbg-ff-main-container"},[_c('div',{staticClass:"error-container",style:(_vm.containerStyle)},[_c('h1',{staticClass:"error-title",style:(_vm.titleStyle)},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"error-description",style:(_vm.descriptionStyle),domProps:{"innerHTML":_vm._s(_vm.description)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }